import { Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";

/** @jsxImportSource @emotion/react */
import { Typography } from "@vc-workspace/utils-typography";
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
export function L2PageFilterList(props) {
  var displayL2Categories = props.categories.filter(function (item) {
    return item.parent === props.currentCategory.parent;
  });
  return _jsxs(_Fragment, {
    children: [!props.withoutHeading ? _jsx(Typography, {
      type: "SubHeading1",
      color: "nero",
      className: "pb-4",
      bold: true,
      children: "Category"
    }) : null, displayL2Categories.map(function (category) {
      return _jsx("a", {
        href: "/category/".concat(category.slug),
        children: _jsxs(Typography, {
          type: "Body1",
          color: category._id === props.currentCategory._id ? "purple_heart" : "dim_grey",
          hover_color: "nero",
          bold: category._id === props.currentCategory._id,
          className: "mb-4 flex items-center",
          children: [_jsx("span", {
            children: category.displayName
          }), category._id === props.currentCategory._id ? _jsx(ChevronRightIcon, {
            fontSize: "small"
          }) : null]
        })
      }, category._id);
    })]
  });
}
export default L2PageFilterList;